<script>
import NewsletterForm from '@phoenix/mixins/components/form/NewsletterForm';
import { PhxGridLayout } from '@sg/src/View/Components/Atoms/GridLayout';

export default {
  components: {
    PhxGridLayout,
  },

  mixins: [NewsletterForm],
};
</script>

<template>
  <phoenix-form
    v-model="fields"
    :action="action"
    :captcha-enabled="enableCaptcha"
    data-cy="newsletter-form"
    form-type="newsletter"
    korean-form-type="newsletter"
    :on-success-callback="addTrackingInformation"
    :prefill-enabled="true"
    :redirect-url="redirectUrl"
    :should-reset-form-on-submit="true"
    :terms-link="termsLink"
    :privacy-link="privacyLink"
    :show-errors-in-toast="true"
  >
    <phx-grid-layout class="md:grid--spacing-3" grid-spacing="6" :has-center-classes="false">
      <form-group :attrs="fields.country" class="col-span-full md:col-span-6">
        <select-field v-model="fields.country.value" />
      </form-group>

      <form-group v-if="fieldIsPresent('title')" :attrs="fields.title" class="col-span-full md:col-span-6">
        <select-field v-model="fields.title.value" />
      </form-group>

      <form-group v-if="fieldIsPresent('gender')" :attrs="fields.gender" class="col-span-full md:col-span-6">
        <select-field v-model="fields.gender.value" />
      </form-group>

      <form-group
        v-if="fieldIsPresent('firstName2') && isArabicLanguage"
        :attrs="fields.firstName2"
        class="col-span-full md:col-span-6"
      >
        <text-field v-model="fields.firstName2.value" />
      </form-group>

      <form-group
        v-if="fieldIsPresent('lastName2') && isArabicLanguage"
        :attrs="fields.lastName2"
        class="col-span-full md:col-span-6"
      >
        <text-field v-model="fields.lastName2.value" />
      </form-group>

      <form-group v-if="fieldIsPresent('firstName1')" :attrs="fields.firstName1" class="col-span-full md:col-span-6">
        <text-field v-model="fields.firstName1.value" />
      </form-group>

      <form-group v-if="fieldIsPresent('lastName1')" :attrs="fields.lastName1" class="col-span-full md:col-span-6">
        <text-field v-model="fields.lastName1.value" />
      </form-group>

      <form-group
        v-if="fieldIsPresent('firstName2') && !isArabicLanguage"
        :attrs="fields.firstName2"
        class="col-span-full md:col-span-6"
      >
        <text-field v-model="fields.firstName2.value" />
      </form-group>

      <form-group
        v-if="fieldIsPresent('lastName2') && !isArabicLanguage"
        :attrs="fields.lastName2"
        class="col-span-full md:col-span-6"
      >
        <text-field v-model="fields.lastName2.value" />
      </form-group>

      <form-group v-if="fieldIsPresent('email')" :attrs="fields.email" class="col-span-full md:col-span-6">
        <text-field v-model="fields.email.value" />
      </form-group>

      <form-group v-if="fieldIsPresent('email')" :attrs="fields.emailConfirmation" class="col-span-full md:col-span-6">
        <text-field v-model="fields.emailConfirmation.value" />
      </form-group>
    </phx-grid-layout>
  </phoenix-form>
</template>
